import React from 'react';
import ReactTable from'react-table';
import 'react-table/react-table.css';
import {FormattedMessage} from 'react-intl';
import {formatDate} from '../../../utils/dateTimeUtils';


class EventsTable extends React.Component {

   render() {
      const columns = [
         {
            Header: <FormattedMessage id="eventTable.title"/>,
            accessor: 'title',
            Cell: props =>
               <div>
                  <p className = "eventTextWrap">{props.value}</p>
               </div>
         },
         {
            Header: <FormattedMessage id="eventTable.date"/>,
            id: 'dateValue',
            accessor: d => formatDate(d.start),
            maxWidth: 175,
            Cell: props =>
               <div className="eventsTableCenteredColumn">
                  <p className = "eventTextWrap">{props.value}</p>
               </div>
         },
         {
            Header: <FormattedMessage id="eventTable.location"/> ,
            accessor: 'location',
            Cell: props =>
               <div>
                  <p className = "eventTextWrap">{props.value}</p>
               </div>,
            minWidth: 190,
         },
         {
            Header: <FormattedMessage id="eventTable.type"/>,
            accessor: 'eventType',
             maxWidth: 150,
             Cell: props =>
                <div className="eventsTableCenteredColumn">
                   <p className = "eventTextWrap">{props.value}</p>
                </div>
         },
          {
              Header: <FormattedMessage id="eventTable.numberOfGuests"/>,
              accessor: 'numOfGuests',
              maxWidth: 125,
              Cell: props =>
                  <div className="eventsTableCenteredColumn">
                      <p className = "eventTextWrap">{props.value}</p>
                  </div>
          }
      ];

      if (!this.props.ghostMode){
          columns.push(
              {
                  Header: <FormattedMessage id="eventTable.numberOfSongs"/>,
                  accessor: 'numOfSongs',
                  maxWidth: 125,
                  Cell: props =>
                      <div className="eventsTableCenteredColumn">
                          <p className = "eventTextWrap">{props.value}</p>
                      </div>
              }
          )
      }

      if (this.props.adminPermission) {
         columns.push(
            {
               Header: <FormattedMessage id="eventTable.djName"/> ,
               accessor: 'dj_name',
               maxWidth: 165,
               Cell: props =>
                  <div className="eventsTableCenteredColumn">
                     <p className = "eventTextWrap">{props.value}</p>
                  </div>,
            }
         );
      }
      return (
            <ReactTable
               className="eventsTable -highlight"
               data={this.props.data}
               columns={columns}
               filterable
               defaultFilterMethod={(filter, row) =>
                  String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())}
               defaultPageSize={20}
               showPageSizeOptions={true}
               getTrProps={(state, rowInfo) => {
                  return {
                     onClick: e => {
                        this.props.handleEventSelected(rowInfo.original);
                     }
                  }
               }}

            />
      )
   }
}


export default EventsTable;



// WEBPACK FOOTER //
// ./src/pages/myEvents/eventsTable/eventsTable.component.js